export default "__VITE_ASSET__Bmr9giWc__"